import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';

import {
    GIS_POINT_ICON_SIZE_PIXELS,
    PointColors,
} from '../../../constants';
import { invertCoordinates } from '../../../helpers/generalFunctions';
import PointIcon from '../icons/PointIcon';
import PointTooltip from '../tooltips/PointTooltip';

import 'leaflet-realtime';
import { dataGeoServiciosFetch } from '../../../helpers/fetch';


export const getPointLayerHisttoric = async (parameters) => {
   
    const pointsGeojson = await dataGeoServiciosFetch(parameters, 'POST');
    const pointMarkers = pointsGeojson.features.map((feature) =>
        createPointMarker(
            invertCoordinates(feature.geometry.coordinates)).bindTooltip(
            ReactDOMServer.renderToString(<PointTooltip {...feature.properties} historic={false} />),
            {
                direction: 'top',
                offset: [0, -35],
            }
        )
    );
    const pointsLayerGroup = new L.LayerGroup(pointMarkers);
    return pointsLayerGroup;

};

const createPointMarker = (latlng) => (
    L.marker(latlng, {
        icon: createPointIcon(),
        pmIgnore: true,
    })
)


/**
 * @param {*} feature - GeoJSON feature, the point varies depending on the feature properties.
 * @param {string} colorPoints - Colors for the points
 * @returns Point icon.
 */
 const createPointIcon = () => {
    return L.divIcon({
        className: '',
        html: ReactDOMServer.renderToString(createPointHtml()),
        iconSize: [GIS_POINT_ICON_SIZE_PIXELS, GIS_POINT_ICON_SIZE_PIXELS],
        iconAnchor: [GIS_POINT_ICON_SIZE_PIXELS / 2, GIS_POINT_ICON_SIZE_PIXELS],
        tooltipAnchor: [0, -GIS_POINT_ICON_SIZE_PIXELS],
    });
};


const createPointHtml = () => {
    return (
        <PointIcon
            fillColor={PointColors[0].fill}
            fontSize={`${GIS_POINT_ICON_SIZE_PIXELS}px`}
            strokeColor={PointColors[0].stroke}
        />
    );

}